import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/EnterpriseDetails.css";
import { formatDateToUserTimeZone } from "../utils/formatDate";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import viewIcon from "../assets/Images/View.png";
import editIcon from "../assets/Images/Edit.png";
import deleteIcon from "../assets/icons/deleteIcon.png";
import changeStatusIcon from "../assets/Images/ChangeStatus.png";
import addIcon from "../assets/Images/AddIcon.png";
import downloadIcon from "../assets/Images/Download.png";
import filterIcon from "../assets/Images/Filter.png";
import crossIcon from "../assets/icons/crossIcon.png";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_MESSAGES } from "../utils/toastMessages";
import usersIcon from "../assets/icons/users.png";
import conversion from "../assets/icons/conversation.png";
import modelsIcon from "../assets/icons/modelsvg.png";
import { useDispatch } from "react-redux";
import { setSelectedMenu } from "../redux/sidebarSlice";

const BASE_URL = `${process.env.REACT_APP_API_URL}/users`;
const ENTERPRISE_URL = `${process.env.REACT_APP_API_URL}/enterprises`;
const ROLE_URL = `${process.env.REACT_APP_API_URL}/roles`;
const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const Domain_Scan = `${process.env.REACT_APP_API_URL}/d-service`;

const APIManagementAdmin = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [enterprises, setEnterprises] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const [dayFilter, setDayFilter] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [userRoleName, setUserRoleName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiKey, setApiKey] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchRolesAndUser = async () => {
      try {
        const res = await api.get(`${process.env.REACT_APP_API_URL}/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const roles = res.data;

        setRoleList(roles);

        const currentUser = JSON.parse(
          localStorage.getItem("user") || sessionStorage.getItem("user")
        );

        const userRole = roles.find((r) => r.role_id === currentUser?.role_fid);
        if (userRole) setUserRoleName(userRole.role_name);
      } catch (err) {
        console.error("Error fetching roles or user info", err);
      }
    };

    fetchRolesAndUser();
  }, []);

  const currentUser = JSON.parse(
    localStorage.getItem("user") || sessionStorage.getItem("user")
  );

  // For when user comes via navigation (e.g., from enterprise click)
  const preselectedEnterpriseId = location.state?.enterpriseId || null;

  // Use this only when needed separately
  const currentUserEnterpriseId = currentUser?.enterprise_fid || null;

  useEffect(() => {
    if (preselectedEnterpriseId) {
      setFormData((prev) => ({
        ...prev,
        enterprise_fid: preselectedEnterpriseId,
      }));
    }
  }, [preselectedEnterpriseId]);

  const [formData, setFormData] = useState({
    domain_name: "",
    ip_address: "",
    json_size: "",
    remaining_api_count: "",
    total_api: "",
    enterprise_fid: "",
    scan_start_time: "",
    allowed_user: "",
    api_count: "",
    payment_freq: "",
    product_name: "",
    subscription_amount: "",
    subscription_description: "",
    subscription_start_date: "",
    subscription_end_date: "",
    subscription_name: "",
    subscription_plan_type: "",
  });

  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const fetchData = async () => {
    try {
      const [roleRes, enterpriseRes] = await Promise.all([
        api.get(ROLE_URL, { headers: { Authorization: `Bearer ${token}` } }),
        api.get(ENTERPRISE_URL, {
          headers: { Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            enterprise_fid:
              currentUser?.enterprise_fid || preselectedEnterpriseId,
          }),
        }),
      ]);
      setRoles(roleRes.data);
      setEnterprises(enterpriseRes.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  const fetchd = async () => {
    try {
      const apiKey = localStorage.getItem("api_key");
      if (apiKey) {
        setApiKey(apiKey);
      }
      const res = await api.get(BASE_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { limit: "all" },
      });
      // const res1 = await api.get(Domain_Scan, {
      //   headers: { Authorization: `Bearer ${token}` },
      //   params: {
      //     enterprise_fid:
      //       currentUser?.enterprise_fid || preselectedEnterpriseId,
      //     limit: "all", // optional, if your backend handles it
      //   },
      // });

      const res2 = await api.get(`${Domain_Scan}/getallDomian`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": apiKey,
        },
      });

      setUsers(res2.data[0].data);
    } catch (error) {
      console.error("Failed to fetch users", error);
      showErrorToast(TOAST_MESSAGES.USER.FETCH_ERROR);
    }
  };

  // const fetchStats = async () => {
  //   try {
  //     const [userCountRes, chatSummaryRes, userAdminCountsRes] =
  //       await Promise.all([
  //         fetch(`${process.env.REACT_APP_API_URL}/users/count/all`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }),
  //         fetch(`${process.env.REACT_APP_API_URL}/chat/summary`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }),
  //         fetch(`${process.env.REACT_APP_API_URL}/users/user-admin-counts`, {
  //           headers: { Authorization: `Bearer ${token}` },
  //         }),
  //       ]);

  //     if (!userCountRes.ok) throw new Error("Failed to fetch user counts");
  //     const userCountData = await userCountRes.json();
  //     setUserCounts(userCountData);

  //     if (!chatSummaryRes.ok) throw new Error("Failed to fetch chat summary");
  //     const chatSummaryData = await chatSummaryRes.json();
  //     setChatStats(chatSummaryData);

  //     if (!userAdminCountsRes.ok)
  //       throw new Error("Failed to fetch user admin counts");
  //     const userAdminCountsData = await userAdminCountsRes.json();

  //     // Correct keys based on your response
  //     setAdminUsersCount({
  //       total: userAdminCountsData.admins.total,
  //       active: userAdminCountsData.admins.active,
  //       inactive: userAdminCountsData.admins.inactive,
  //     });

  //     setRegularUsersCount({
  //       total: userAdminCountsData.users.total,
  //       active: userAdminCountsData.users.active,
  //       inactive: userAdminCountsData.users.inactive,
  //     });
  //   } catch (err) {
  //     console.error("fetchStats error:", err);
  //     showErrorToast(TOAST_MESSAGES.ENTERPRISE.FETCH_ERROR);
  //   }
  // };

  useEffect(() => {
    // fetchStats();
  }, []);

  useEffect(() => {
    fetchData();
    fetchd();
  }, []);

  const filteredUsers = users
    .filter((user) => {
      if (preselectedEnterpriseId) {
        return String(user.enterprise.id) === String(preselectedEnterpriseId);
      }
      return true;
    })
    .filter(
      (user) =>
        user.enterprise?.name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        user.enterprise?.domain_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
    )
    .filter((user) => {
      if (!dayFilter) return true;
      const createdDate = user.subscription?.created_timestamp
        ? new Date(user.subscription.created_timestamp)
        : null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (dayFilter === "Today") return createdDate >= today;
      if (dayFilter === "Yesterday") {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        return createdDate >= yesterday && createdDate < today;
      }
      return true;
    })
    .sort((a, b) => {
      const dateA = new Date(a.updated_timestamp);
      const dateB = new Date(b.updated_timestamp);
      return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
    });

  useEffect(() => {
    if (showForm && userRoleName === "Admin" && currentUserEnterpriseId) {
      setFormData((prev) => ({
        ...prev,
        enterprise_fid: currentUserEnterpriseId,
      }));
    }
  }, [showForm, userRoleName, currentUserEnterpriseId]);

  const totalEntries = filteredUsers.length;
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;
  const currentData = filteredUsers.slice(indexOfFirst, indexOfLast);
  const showingFrom = totalEntries === 0 ? 0 : indexOfFirst + 1;
  const showingTo = Math.min(indexOfLast, totalEntries);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleEntriesChange = (e) => {
    setEntriesPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handlePageClick = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleView = (user) => {
    // setFormData({
    //   domain_name: user.enterprise.domain_name,
    //   ip_address: "",
    //   json_size: "",
    //   remaining_api_count: user.subscription.api_count,
    //   total_api: user.subscription.api_count,
    //   enterprise_fid: user.enterprise.id,
    //   scan_start_time: user.subscription.scan_start_time,
    //   allowed_user: user.subscription.allowed_user,
    //   api_count: user.subscription.api_count,
    //   payment_freq: user.subscription.payment_freq,
    //   product_name: user.subscription.product_name,
    //   subscription_amount: user.subscription.subscription_amount,
    //   subscription_description: user.subscription.subscription_description,
    //   subscription_start_date: user.subscription.subscription_start_date,
    //   subscription_end_date: user.subscription.subscription_end_date,
    //   subscription_name: user.subscription.subscription_name,
    //   subscription_plan_type: user.subscription.subscription_plan_type,
    //   features: user.subscription.features || {},
    // });

    setSelectedUser(user);
    setViewMode(true);
    setShowForm(true);
  };

  const handleReset = () => {
    setSortOrder("desc");
    setDayFilter("");
    setSearchTerm("");
    setCurrentPage(1);
  };
  const resetForm = () => {
    setFormData({
      domain_name: "",
      ip_address: "",
      json_size: "",
      remaining_api_count: "",
      total_api: "",
      enterprise_fid: "",
      scan_start_time: "",
      allowed_user: "",
      api_count: "",
      payment_freq: "",
      product_name: "",
      subscription_amount: "",
      subscription_description: "",
      subscription_start_date: "",
      subscription_end_date: "",
      subscription_name: "",
      subscription_plan_type: "",
    });
    setEditingId(null);
    setShowForm(false);
    setViewMode(false);
  };

  const currentEnterprise = enterprises.find(
    (e) => e.enterprise_id === String(currentUserEnterpriseId)
  );

  // console.log("Current user enterprise ID:", currentUserEnterpriseId);
  // console.log(
  //   "All enterprise IDs:",
  //   enterprises.map((e) => e.enterprise_id)
  // );
  // console.log("Matched enterprise:", currentEnterprise);

  const statsData = [
    {
      label: "Total API",
      value:
        (currentEnterprise?.used_api_count || 0) +
        (currentEnterprise?.remaining_api_count || 0),
      summary: [
        { label: "Used API", value: currentEnterprise?.used_api_count || 0 },
        {
          label: "Remaining API",
          value: currentEnterprise?.remaining_api_count || 0,
        },
      ],
      icon: usersIcon,
    },
  ];

  const getVisiblePages = () => {
    let start = currentPage - 1;
    let end = currentPage + 1;

    // Fix lower bound
    if (start < 1) {
      start = 1;
      end = 2;
    }

    // Fix upper bound
    if (end > totalPages) {
      end = totalPages;
      start = totalPages - 1;
      if (start < 1) start = 1;
    }

    let pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <div className="mx-2 pt-1 h-100">
      <div
        className="d-flex flex-wrap gap-3 mb-2 mt-0  justify-content-evenly align-items-center"
        style={{ maxWidth: "400px" }}
      >
        {statsData.map((item, index) => (
          <div key={index} className="dashboard-box p-3 rounded shadow-sm">
            <div className="d-flex align-items-center mb-1">
              {item.icon && (
                <img
                  src={item.icon}
                  alt={item.label}
                  style={{
                    width: "21px",
                    height: "21px",
                  }}
                  className="icon-image1"
                />
              )}
              <h6 className="ms-2 mb-0">{item.label}</h6>
            </div>

            <h2 className="fw-bold">
              {typeof item.value !== "undefined" ? item.value : "0"}
            </h2>

            <div className="box-summary">
              {item.summary && item.summary.length > 0 ? (
                item.summary.map((s, i) => (
                  <span key={i}>
                    {s.label}: {s.value}
                  </span>
                ))
              ) : (
                <span className="invisible">placeholder</span> // Keeps space but invisible
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2 mt-1 ">
        <span className="fw-bold refresh-prompts" style={{ fontSize: "20px" }}>
          API Management Details
        </span>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center">
          <select
            className="form-select w-auto"
            value={entriesPerPage}
            onChange={handleEntriesChange}
          >
            {[50, 100, 500].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <label className="ms-2 mt-2">Entries per page</label>
        </div>

        <div className="d-flex align-items-center">
          <div className="custom-search-wrapper me-3">
            <div className="input-group custom-search-group">
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search Users"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          {/* <button
            className="btn btn-outline-secondary me-2 action-button"
            onClick={exportExcel}
          >
            <img src={downloadIcon} className="icon-image" alt="Download" />
          </button> */}

          <div className="">
            <button
              className="btn icon-button filter-dropdown-toggle action-button"
              type="button"
              data-bs-toggle="dropdown"
            >
              <img src={filterIcon} className="icon-image" alt="Filter" />
            </button>

            <div
              className="dropdown-menu profile-menu-dropdown p-2"
              style={{ minWidth: "200px" }}
            >
              <h6 className="fw-bolder refresh-prompts">Time</h6>
              <hr />
              {["asc", "desc"].map((order) => (
                <div className="form-check" key={order}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="sortOrder"
                    id={order}
                    value={order}
                    checked={sortOrder === order}
                    onChange={() => setSortOrder(order)}
                  />
                  <label className="form-check-label" htmlFor={order}>
                    {order === "asc" ? "Ascending" : "Descending"}
                  </label>
                </div>
              ))}

              <hr />
              <h6 className="fw-bolder refresh-promts">By Day</h6>
              <hr />
              {["Today", "Yesterday", ""].map((day) => (
                <div className="form-check" key={day || "all"}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="dayFilter"
                    id={day || "all"}
                    value={day}
                    checked={dayFilter === day}
                    onChange={() => setDayFilter(day)}
                  />
                  <label className="form-check-label" htmlFor={day || "all"}>
                    {day || "All"}
                  </label>
                </div>
              ))}

              <hr />
              <div className="d-flex justify-content-between mt-2">
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  className="btn dropdown-btn bg-dark text-white btn-sm"
                  onClick={() => {
                    setCurrentPage(1);
                  }}
                >
                  Apply Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {totalEntries === 0 ? (
        <div className="text-center my-5">
          <p className="refresh-prompts fs-5">No entries found</p>
        </div>
      ) : (
        <div className="not-disable">
          <div className="table-responsive h-100 border rounded-2">
            <table className="table user-table1 table-sm w-100 ">
              <thead>
                <tr>
                  <th>Domain Name</th>
                  <th>IP Address</th>
                  {/* <th>Used API (Scan)</th> */}
                  <th>File Size</th>
                  <th>Scan Start Time</th>
                  <th>Scan End Time</th>
                  <th>Status</th>
                  <th className="text-center">Response JSON</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.domain_name.toLowerCase() || "-"}</td>
                    <td>{item.ip_address || "-"}</td>
                    {/* <td>{item.used_api_count || "-"}</td> */}
                    <td>{item.file_size ?? "-"}</td>

                    <td>
                      {item.scan_start_time
                        ? formatDateToUserTimeZone(item.scan_start_time)
                        : "-"}
                    </td>
                    <td>
                      {item.scan_end_time
                        ? formatDateToUserTimeZone(item.scan_end_time)
                        : "-"}
                    </td>
                    <td>
                      {item.status
                        ? item.status.charAt(0).toUpperCase() +
                          item.status.slice(1)
                        : "-"}
                    </td>

                    <td className="text-center">
                      <button
                        className="icon-button"
                        onClick={() => handleView(item)}
                        title="View"
                      >
                        <img src={viewIcon} className="icon-image" alt="View" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-footer text-center bgcolor fixed-bottom-footer d-md-flex justify-content-sm-between align-items-center ">
            <div className="refresh-prompts pb-2 pb-md-0">
              Showing {showingFrom} to {showingTo} of {totalEntries} entries
            </div>
            <ul className="pagination mb-0 justify-content-center">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(1)}
                >
                  <i className="bi bi-chevron-double-left" />
                </button>
              </li>
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage - 1)}
                >
                  <i className="bi bi-chevron-left" />
                </button>
              </li>
              {getVisiblePages().map((num) => (
                <li
                  key={num}
                  className={`page-item ${currentPage === num ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(num)}
                  >
                    {num}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(currentPage + 1)}
                >
                  <i className="bi bi-chevron-right" />
                </button>
              </li>
              <li
                className={`page-item ${
                  currentPage === totalPages ? "disabled" : ""
                }`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageClick(totalPages)}
                >
                  <i className="bi bi-chevron-double-right" />
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}

      {showForm && selectedUser && (
        <div className="modal modal-backdrop-custom d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content w-100 mx-auto">
              <form>
                <div className="modal-header justify-content-center">
                  <h5 className="modal-title">
                    {viewMode
                      ? "View Response Details"
                      : editingId
                      ? "Update API and Subscription Details"
                      : "Add API and Subscription Details"}
                  </h5>
                  <button
                    type="button"
                    className="modal-close-btn"
                    onClick={resetForm}
                    aria-label="Close"
                  >
                    <img src={crossIcon} className="icon-image" alt="Close" />
                  </button>
                </div>

                <div className="modal-body refresh-prompts">
                  <pre
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      padding: "1rem",
                      borderRadius: "5px",
                    }}
                    className="refresh-prompts border"
                  >
                    {JSON.stringify(selectedUser, null, 2)}
                  </pre>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="cancle-btn"
                    onClick={resetForm}
                  >
                    {viewMode ? "Close" : "Cancel"}
                  </button>
                  {!viewMode && (
                    <button type="submit" className="custom-btn">
                      {editingId ? "Update" : "Submit"}
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default APIManagementAdmin;
